<div class="flex bg-primary-50 h-100p relative">
    <form
        [formGroup]="registrationForm"
        (submit)="submit()"
        class="flex flex-col items-center shadow-md text-center bg-neutral-100 w-full md:w-[566px] mx-auto md:mx-auto my-12 pt-5 pb-7 px-10 md:px-20 rounded-lg"
    >
        <img
            class="max-w-[200px] m-5"
            src="assets/images/EWA_Logo.jpg"
            alt="EWA Logo"
        />

        <section class="mb-3 flex flex-col text-center">
            <h1 class="text-tertiary-900">EWA Account Creation</h1>
            <p>Lastly, please complete your account profile.</p>
        </section>

        <section class="flex w-full">
            <mat-form-field
                appearance="outline"
                class="rounded-full w-full md:w-32"
            >
                <mat-label>Prefix</mat-label>
                <mat-select formControlName="prefix">
                    @for (prefix of prefixes; track prefix.value) {
                        <mat-option value="{{ prefix.value }}">
                            {{ prefix.text }}
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </section>

        <section class="flex flex-row space-x-3 w-full">
            <mat-form-field appearance="outline" class="w-full">
                <mat-label>First Name</mat-label>
                <input
                    title="First name"
                    matInput
                    [pattern]="
                        regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                    "
                    minlength="3"
                    maxlength="30"
                    formControlName="firstName"
                />
            </mat-form-field>
            <mat-form-field appearance="outline" class="w-full">
                <mat-label>Last Name</mat-label>
                <input
                    title="Last name"
                    matInput
                    [pattern]="
                        regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                    "
                    minlength="3"
                    maxlength="50"
                    formControlName="lastName"
                />
            </mat-form-field>
        </section>

        <section class="flex flex-col w-full">
            <mat-form-field appearance="outline">
                <mat-label>Job Title</mat-label>
                <input
                    title="Job title"
                    matInput
                    minlength="3"
                    maxlength="50"
                    [pattern]="
                        regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                    "
                    formControlName="jobTitle"
                />
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Phone Number</mat-label>
                <input
                    title="Phone number"
                    class=""
                    type="tel"
                    [showMaskTyped]="true"
                    [specialCharacters]="
                        phoneConstants.SPECIAL_CHARACTERS_WITH_EXTENSION
                    "
                    [dropSpecialCharacters]="
                        phoneConstants.DROP_SPECIAL_CHARACTERS_WITH_EXTENSION
                    "
                    placeHolderCharacter="_"
                    [shownMaskExpression]="
                        phoneConstants.SHOWN_MASK_EXPRESSION_WITH_EXTENSION
                    "
                    [mask]="phoneConstants.MASK_WITH_EXTENSION"
                    matInput
                    formControlName="phoneNumber"
                />
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Company/Organization</mat-label>
                <input
                    title="Organization name"
                    matInput
                    [appRegexInput]="
                        regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                    "
                    minlength="3"
                    maxlength="80"
                    formControlName="organizationName"
                />
            </mat-form-field>
        </section>

        <section class="flex flex-col w-full relative">
            <mat-form-field appearance="outline">
                <mat-label>Street Address</mat-label>
                <input
                    title="Street address"
                    matInput
                    minlength="1"
                    maxlength="100"
                    [pattern]="
                        regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                    "
                    spellcheck="false"
                    formControlName="streetAddress"
                    (input)="poBoxOrAddressToggle()"
                />
            </mat-form-field>

            <img
                [matTooltipPosition]="'right'"
                matTooltip="For office/suite, apartment numbers please add them in the street address field."
                src="assets/svg/question-tooltip.svg"
                alt="question mark"
                class="!fill-primary-700 cursor-pointer absolute -right-7 top-3 w-5 h-5"
            />

            <div class="relative select-none !m-0">
                <div
                    class="absolute -left-7 -top-[55px] flex flex-col items-center"
                >
                    <img
                        src="assets/svg/vertical-line-top-curve-right.svg"
                        alt="or top bracket"
                        aria-hidden="true"
                    />
                    <div class="text-tertiary-600 mr-3" aria-label="or">Or</div>
                    <img
                        src="assets/svg/vertical-line-top-curve-right.svg"
                        alt="or bottom bracket"
                        aria-hidden="true"
                        class="scale-y-[-1]"
                    />
                </div>
            </div>

            <mat-form-field appearance="outline">
                <mat-label>PO Box</mat-label>
                <input
                    title="PO box"
                    matInput
                    minlength="1"
                    maxlength="50"
                    [pattern]="
                        regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                    "
                    spellcheck="false"
                    formControlName="poBox"
                    (input)="poBoxOrAddressToggle()"
                />
            </mat-form-field>
        </section>

        <section class="flex w-full">
            <mat-form-field appearance="outline" class="w-full">
                <mat-label>City</mat-label>
                <input
                    title="City"
                    matInput
                    minlength="3"
                    maxlength="50"
                    [pattern]="
                        regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                    "
                    formControlName="city"
                />
            </mat-form-field>
        </section>
        <section class="flex flex-col md:flex-row w-full md:space-x-3">
            <mat-form-field appearance="outline" class="w-full grow">
                <mat-label>State</mat-label>
                <mat-select formControlName="stateProvinceId">
                    @for (
                        stateProvince of stateProvinces;
                        track stateProvince.id
                    ) {
                        <mat-option value="{{ stateProvince.id }}">
                            {{ stateProvince.name }}
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>

            <mat-form-field
                appearance="outline"
                class="flex-none w-full md:w-32"
            >
                <mat-label>ZIP Code</mat-label>
                <input
                    title="ZIP code"
                    matInput
                    [pattern]="regExPattern.PostalCode"
                    [imask]="maskOptions.postalCode"
                    [unmask]="true"
                    formControlName="postalCode"
                />
            </mat-form-field>
        </section>

        <section class="w-full">
            <mat-form-field appearance="outline" class="w-full">
                <mat-label>Company type</mat-label>
                <mat-select formControlName="organizationType">
                    @for (
                        organizationType of organizationTypes;
                        track organizationType.value
                    ) {
                        <mat-option value="{{ organizationType.value }}">
                            {{ organizationType.description }}
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>

            @if (showOrganizationTypeOtherField()) {
                <mat-form-field appearance="outline" class="w-full">
                    <mat-label>If Other Please Specify</mat-label>
                    <input
                        title="Company type (other)"
                        matInput
                        minlength="3"
                        maxlength="50"
                        [pattern]="
                            regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                        "
                        formControlName="otherOrganizationType"
                    />
                </mat-form-field>
            }
        </section>

        <button
            type="submit"
            title="Complete Account"
            class="w-full !rounded-lg"
            mat-raised-button
            color="primary"
            [disabled]="!registrationForm.valid"
        >
            <div class="!w-full text-2xl leading-9 font-normal">
                Complete Account
            </div>
        </button>
    </form>
</div>
